import React from "react";

import "./Steps.css";

interface RfrInputProps {
    label: string,
    required: boolean,
    name: string,
    type: "text" | "number",
    className?: string,
    placeholder?: string,
    disabled?: boolean,
    onInput?: (e) => void,
    value: string
}

export default function RfrInput(props: RfrInputProps) {

    const handleInputData = (event) => {
        const { value } = event.target;
        if (props.type === "number") {
            const i = parseInt(value.replace(/[^0-9]/g, ''), 10);
            if (i === 0 || Number.isNaN(i)) {
                event.target.value = "";
            } else {
                event.target.value = i.toString();
            }
        }
        props.onInput(event);
    }

    return (
        <>
            <div className="rfr-form-row">
                <div className="rfr-form-row-desc">
                    {props.required ?
                        <div className="row-desc-required">*</div>
                        :
                        <div className="row-desc-required"></div>
                    }
                    <div className="max-wdith-desc">
                        <label htmlFor={props.name} className="font-blue">{props.label}:</label>
                    </div>
                </div>
                <div className="rfr-input-block">
                    <input onChange={(e) => handleInputData(e)} type="text" name={props.name} id={props.name} className="rfr-form-input-long" disabled={props.disabled} value={props.value} />
                </div>
            </div>
        </>
    )
}